import { useContext } from 'react';
import { atom, useAtom } from 'jotai';
import { MobilePOSContext } from './OrderMobilePOS.provider';

type MobilePOSOrderDetails = {
  id?: string;
  email?: string;
  quantity?: string;
  price?: string;
  subtotal?: number;
  shipping?: number;
  total?: number;
};

const orderDetailsAtom = atom<MobilePOSOrderDetails | undefined>(undefined);
const orderSuccessAtom = atom<boolean>(false);

const useMobilePOSProvider = () => {
  const store = useContext(MobilePOSContext);
  const [orderDetails, setOrderDetails] = useAtom(orderDetailsAtom, { store: store });
  const [orderSuccess, setOrderSuccess] = useAtom(orderSuccessAtom, { store: store });

  return {
    orderDetails,
    setOrderDetails,
    orderSuccess,
    setOrderSuccess,
    causeId: store?.causeId,
  };
};

export { useMobilePOSProvider };
